// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goEKp6P2OA4PFU1SQlTL {
  border: 1px solid #e7eaed;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  background: #fff;
}

.FDYsrxxbTODvBaB1mmUW {
  font-size: 14px;
  line-height: 20px;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  color: var(--main-color-text-first) !important;
}

.FDYsrxxbTODvBaB1mmUW th {
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  background-color: rgba(45, 117, 135, 0.08) !important;
  color: var(--main-color-first);
  padding: 10px 8px;
  border: none;
  border-bottom: 2px solid rgba(45, 117, 135, 0.18);
}

.FDYsrxxbTODvBaB1mmUW td {
  cursor: pointer !important;
}

.FDYsrxxbTODvBaB1mmUW td {
  border: none;
  border-bottom: 1px solid #eef0f2;
  padding: 8px !important;
}

.FDYsrxxbTODvBaB1mmUW th {
  padding: 10px 8px !important;
}

.FDYsrxxbTODvBaB1mmUW tbody tr {
  transition: background-color 0.15s ease;
}

.FDYsrxxbTODvBaB1mmUW tbody tr:last-child td {
  border-bottom: none;
}

/* Survol des lignes du tableau */
.FDYsrxxbTODvBaB1mmUW tbody tr:hover {
  background-color: rgba(45, 117, 135, 0.06);
}

.FDYsrxxbTODvBaB1mmUW input[type="checkbox"] {
  opacity: 1 !important;
  position: static !important;
  pointer-events: auto !important;
  accent-color: var(--main-color-first);
}


.Hq_01TCw4SOBKXss2it3 {
  position: sticky;
  top: 0;
  z-index: 9;
}

.D57lReKTz4U1GIexE5Lu {
  scrollbar-width: thin;
  scrollbar-color: #2d7587 #e0e0e0;
}

/* Pour Chrome, Edge, Safari */
.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar {
  width: 8px; 
  height: 8px; 
}

.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar-track {
  background: #f0f0f0; 
}

.D57lReKTz4U1GIexE5Lu::-webkit-scrollbar-thumb {
  background-color: var(--main-color-fourth) !important; 
  border-radius: 4px; 
  border: 2px solid #f0f0f0; 
}

.z27y0eY6B4yB5EuxWqM7 {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.cANeoTHQq1yUyv4X4OB5 {
  display: flex;
  gap: 5px;
  align-items: center;
}

.zJ2nzzyCrlBnHdAtrZkL {
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e2e5e9;
  background-color: #fff;
  border-radius: 6px;
  min-width: 28px;
  cursor: pointer;
  margin: 0 2px;
  transition: all 0.15s ease;
}

.zJ2nzzyCrlBnHdAtrZkL:hover:not(:disabled) {
  background-color: rgba(45, 117, 135, 0.08);
  border-color: var(--main-color-first);
}

.zJ2nzzyCrlBnHdAtrZkL:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.zJ2nzzyCrlBnHdAtrZkL:focus {
  background-color: inherit;
  box-shadow: none;
  outline: none;
}

.kvN22hEtLL3RvO0gJbmi {
  font-weight: 600;
  color: #fff !important;
  border-color: var(--main-color-first) !important;
  background-color: var(--main-color-first) !important;
}

.MVjlbA8f3B7eWFYbyqqi{
  font-size: 13px;
  color: var(--main-color-text-first) !important;
  margin-top: 20px;
}

/* Barre d'outils : recherche + actions sur une seule ligne */
.k6zZdC9EHVwJBrSPku4O{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.iBLKnCgdJsT6LgdSrjLt{
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
}

.fWJYn4ahmcOCGLA6yqsv{
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.Kkp5JNrFTbZks5dDBdVn{
  position: relative;
  flex: 1 1 140px;
  min-width: 110px;
  max-width: 220px;
}

.q4FC0mkc0DNlQFMobCL5{
  background-color: #f2f4f5 !important;
  border-radius: 8px !important;
  height: 34px !important;
  border: 1px solid transparent !important;
  width: 100% !important;
  padding-left: 36px !important;
  font-size: 14px !important;
  margin-bottom: 0 !important;
  transition: all 0.15s ease;
}
.q4FC0mkc0DNlQFMobCL5:focus{
  border: 1px solid var(--main-color-first) !important;
  background-color: #fff !important;
  box-shadow: 0 0 0 3px rgba(45, 117, 135, 0.12) !important;
}

.ea256NIp2JcSFzpgEBYE{
  left: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #8a949c;
  font-size: 13px;
}

.pGx_H7OxaIZSiSCxLm1f {
  display: flex;
  align-items: center;
  gap: 5px;
  background: #f5f5f5;
  margin-bottom: 1px;
}

.ejPiq1QSJX4CTkzSF8lP {
  background: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.ejPiq1QSJX4CTkzSF8lP:hover {
  background: #ccc !important;
}

.ejPiq1QSJX4CTkzSF8lP:focus {
  background: none !important;
}

.rSWYoJmDywtOL4K2fZlw{
  background: rgba(45, 117, 135, 0.1) !important;
}
/* Ligne épinglée en tête (ex : collection en cours de création) */
.oINFJfiwKMky6oJi2dDO {
  background-color: rgba(45, 117, 135, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/component/resultat/resultatForm.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qDAAqD;EACrD,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;AACvC;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,wCAAwC;EACxC,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oDAAoD;EACpD,iCAAiC;EACjC,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;AACA,kEAAkE;AAClE;EACE,0CAA0C;AAC5C","sourcesContent":[".tableCard {\r\n  border: 1px solid #e7eaed;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\r\n  background: #fff;\r\n}\r\n\r\n.customtable {\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n  color: var(--main-color-text-first) !important;\r\n}\r\n\r\n.customtable th {\r\n  text-align: center;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.4px;\r\n  background-color: rgba(45, 117, 135, 0.08) !important;\r\n  color: var(--main-color-first);\r\n  padding: 10px 8px;\r\n  border: none;\r\n  border-bottom: 2px solid rgba(45, 117, 135, 0.18);\r\n}\r\n\r\n.customtable td {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.customtable td {\r\n  border: none;\r\n  border-bottom: 1px solid #eef0f2;\r\n  padding: 8px !important;\r\n}\r\n\r\n.customtable th {\r\n  padding: 10px 8px !important;\r\n}\r\n\r\n.customtable tbody tr {\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.customtable tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Survol des lignes du tableau */\r\n.customtable tbody tr:hover {\r\n  background-color: rgba(45, 117, 135, 0.06);\r\n}\r\n\r\n.customtable input[type=\"checkbox\"] {\r\n  opacity: 1 !important;\r\n  position: static !important;\r\n  pointer-events: auto !important;\r\n  accent-color: var(--main-color-first);\r\n}\r\n\r\n\r\n.stickyHeader {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 9;\r\n}\r\n\r\n.scrollablediv {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #2d7587 #e0e0e0;\r\n}\r\n\r\n/* Pour Chrome, Edge, Safari */\r\n.scrollablediv::-webkit-scrollbar {\r\n  width: 8px; \r\n  height: 8px; \r\n}\r\n\r\n.scrollablediv::-webkit-scrollbar-track {\r\n  background: #f0f0f0; \r\n}\r\n\r\n.scrollablediv::-webkit-scrollbar-thumb {\r\n  background-color: var(--main-color-fourth) !important; \r\n  border-radius: 4px; \r\n  border: 2px solid #f0f0f0; \r\n}\r\n\r\n.paginationContainer {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.paginationButtons {\r\n  display: flex;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.paginationButton {\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  border: 1px solid #e2e5e9;\r\n  background-color: #fff;\r\n  border-radius: 6px;\r\n  min-width: 28px;\r\n  cursor: pointer;\r\n  margin: 0 2px;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.paginationButton:hover:not(:disabled) {\r\n  background-color: rgba(45, 117, 135, 0.08);\r\n  border-color: var(--main-color-first);\r\n}\r\n\r\n.paginationButton:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.4;\r\n}\r\n\r\n.paginationButton:focus {\r\n  background-color: inherit;\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.paginationButtonActive {\r\n  font-weight: 600;\r\n  color: #fff !important;\r\n  border-color: var(--main-color-first) !important;\r\n  background-color: var(--main-color-first) !important;\r\n}\r\n\r\n.paginationtext{\r\n  font-size: 13px;\r\n  color: var(--main-color-text-first) !important;\r\n  margin-top: 20px;\r\n}\r\n\r\n/* Barre d'outils : recherche + actions sur une seule ligne */\r\n.toolbarRow{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.toolbarLeftGroup{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n}\r\n\r\n.actionsRightGroup{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.searchInputCtn{\r\n  position: relative;\r\n  flex: 1 1 140px;\r\n  min-width: 110px;\r\n  max-width: 220px;\r\n}\r\n\r\n.searchInput{\r\n  background-color: #f2f4f5 !important;\r\n  border-radius: 8px !important;\r\n  height: 34px !important;\r\n  border: 1px solid transparent !important;\r\n  width: 100% !important;\r\n  padding-left: 36px !important;\r\n  font-size: 14px !important;\r\n  margin-bottom: 0 !important;\r\n  transition: all 0.15s ease;\r\n}\r\n.searchInput:focus{\r\n  border: 1px solid var(--main-color-first) !important;\r\n  background-color: #fff !important;\r\n  box-shadow: 0 0 0 3px rgba(45, 117, 135, 0.12) !important;\r\n}\r\n\r\n.searchIcon{\r\n  left: 12px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #8a949c;\r\n  font-size: 13px;\r\n}\r\n\r\n.bulkActionBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  background: #f5f5f5;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.bulkActionButton {\r\n  background: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.bulkActionButton:hover {\r\n  background: #ccc !important;\r\n}\r\n\r\n.bulkActionButton:focus {\r\n  background: none !important;\r\n}\r\n\r\n.selectedRow{\r\n  background: rgba(45, 117, 135, 0.1) !important;\r\n}\n/* Ligne épinglée en tête (ex : collection en cours de création) */\n.pinnedRow {\n  background-color: rgba(45, 117, 135, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableCard": `goEKp6P2OA4PFU1SQlTL`,
	"customtable": `FDYsrxxbTODvBaB1mmUW`,
	"stickyHeader": `Hq_01TCw4SOBKXss2it3`,
	"scrollablediv": `D57lReKTz4U1GIexE5Lu`,
	"paginationContainer": `z27y0eY6B4yB5EuxWqM7`,
	"paginationButtons": `cANeoTHQq1yUyv4X4OB5`,
	"paginationButton": `zJ2nzzyCrlBnHdAtrZkL`,
	"paginationButtonActive": `kvN22hEtLL3RvO0gJbmi`,
	"paginationtext": `MVjlbA8f3B7eWFYbyqqi`,
	"toolbarRow": `k6zZdC9EHVwJBrSPku4O`,
	"toolbarLeftGroup": `iBLKnCgdJsT6LgdSrjLt`,
	"actionsRightGroup": `fWJYn4ahmcOCGLA6yqsv`,
	"searchInputCtn": `Kkp5JNrFTbZks5dDBdVn`,
	"searchInput": `q4FC0mkc0DNlQFMobCL5`,
	"searchIcon": `ea256NIp2JcSFzpgEBYE`,
	"bulkActionBar": `pGx_H7OxaIZSiSCxLm1f`,
	"bulkActionButton": `ejPiq1QSJX4CTkzSF8lP`,
	"selectedRow": `rSWYoJmDywtOL4K2fZlw`,
	"pinnedRow": `oINFJfiwKMky6oJi2dDO`
};
export default ___CSS_LOADER_EXPORT___;
